"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetSearchType = void 0;

var _get2 = _interopRequireDefault(require("lodash/get"));

var _constants = require("../../../components/Cigarette/constants");

var _useGetSearchParams = require("./useGetSearchParams");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var useGetSearchType = function useGetSearchType() {
  var searchParams = (0, _useGetSearchParams.useGetSearchParams)();
  return (0, _get2["default"])(searchParams, 'search_type', _constants.SEARCH_TYPE_NAMES.PACKAGE);
};

exports.useGetSearchType = useGetSearchType;